(function () {
  var DURATION_MS = 5000;

  function initStories(root) {
    var slides = root.querySelectorAll('[data-pfc-story-slide]');
    var quotes = root.querySelectorAll('[data-pfc-story-quote]');
    var bars = root.querySelectorAll('[data-pfc-story-bar]');
    if (slides.length < 2 || bars.length !== slides.length) return;

    var index = 0;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function fillEl(i) {
      return bars[i] && bars[i].querySelector('.pfc-stories__bar-fill');
    }

    function setActive(next) {
      index = (next + slides.length) % slides.length;

      slides.forEach(function (slide, i) {
        var on = i === index;
        slide.classList.toggle('is-active', on);
        if (on) slide.removeAttribute('aria-hidden');
        else slide.setAttribute('aria-hidden', 'true');
      });

      quotes.forEach(function (quote, i) {
        var on = i === index;
        quote.classList.toggle('is-active', on);
        if (on) quote.removeAttribute('aria-hidden');
        else quote.setAttribute('aria-hidden', 'true');
      });

      bars.forEach(function (bar, i) {
        var fill = fillEl(i);
        bar.classList.remove('is-active', 'is-done');
        if (i === index) bar.setAttribute('aria-current', 'true');
        else bar.removeAttribute('aria-current');
        if (fill) {
          fill.style.animation = 'none';
          fill.style.width = i < index ? '100%' : '0%';
        }
        if (i < index) {
          bar.classList.add('is-done');
        }
        if (i === index) {
          bar.classList.add('is-active');
          if (fill && !reduceMotion) {
            void fill.offsetWidth;
            fill.style.animation = 'pfc-story-fill ' + DURATION_MS + 'ms linear forwards';
          } else if (fill) {
            fill.style.width = '100%';
          }
        }
      });
    }

    bars.forEach(function (bar, i) {
      var fill = fillEl(i);
      if (fill) {
        fill.addEventListener('animationend', function (event) {
          if (event.animationName !== 'pfc-story-fill') return;
          if (i !== index) return;
          if (root.classList.contains('is-paused')) return;
          setActive(index + 1);
        });
      }

      bar.addEventListener('click', function (event) {
        event.preventDefault();
        setActive(Number(bar.getAttribute('data-pfc-story-bar')) || 0);
      });
    });

    root.addEventListener('mouseenter', function () {
      root.classList.add('is-paused');
    });
    root.addEventListener('mouseleave', function () {
      root.classList.remove('is-paused');
    });
    root.addEventListener('focusin', function () {
      root.classList.add('is-paused');
    });
    root.addEventListener('focusout', function (event) {
      if (!root.contains(event.relatedTarget)) root.classList.remove('is-paused');
    });

    setActive(0);
  }

  function boot() {
    document.querySelectorAll('[data-pfc-stories]').forEach(initStories);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
